import { gql } from '@apollo/client'

// Default dashboard view: the signed-in sale's own book.
// bookHealths -> the 6 stat tiles; customerHoldings -> the CLV-sorted table.
// clvSegment is optional; pass null to show every segment.
export const CUSTOMER_DASHBOARD_QUERY = gql`
  query CustomerDashboard($clvSegment: ClvSegmentEnum) {
    currentStaff {
      id
      fullName
      bookHealths {
        id
        team
        customersHeld
        customersActive
        customersAtRisk
        customersChurned
        activeBookClvSatangs
        activeBookLifetimeRevenueSatangs
        activeBookQ90RevenueSatangs
      }
      customerHoldings(clvSegment: $clvSegment) {
        id
        clvSegment
        predictedClvSatangs
        lifetimeRevenueSatangs
        q90RevenueSatangs
        daysSinceLastOrder
        customer {
          id
          customerNo
          fullName
          phoneNumber
          email
          lineId
          lineUrl
          companies {
            id
            name
          }
        }
      }
    }
  }
`

// Search view: grouped by company. Customers come from searchCustomers
// (each carries its companies + performance); company meta + projects come
// from searchCompanies. Q90 revenue is only available per-holding, so it is
// not part of the per-customer performance here.
export const SEARCH_CUSTOMERS_COMPANIES_QUERY = gql`
  query SearchCustomersCompanies($query: String!) {
    searchCustomers(query: $query, first: 50) {
      nodes {
        id
        customerNo
        fullName
        phoneNumber
        email
        lineId
        lineUrl
        companies {
          id
          name
        }
        performance {
          id
          clvSegment
          predictedClvSatangs
          historicalRevenueClvSatangs
          daysSinceLastOrder
        }
      }
    }
    searchCompanies(query: $query, per: 50) {
      id
      number
      name
      taxId
      addressDetail
      projects {
        id
        name
        status
        paidPrice {
          value
          display
        }
      }
    }
  }
`

// Typeahead for the "add existing contact" flow. Returns each customer's
// current companies so we can union-in the target company on update rather
// than overwrite the whole set.
export const CONTACT_TYPEAHEAD_QUERY = gql`
  query ContactTypeahead($query: String!) {
    searchCustomers(query: $query, first: 20) {
      nodes {
        id
        customerNo
        fullName
        phoneNumber
        email
        companies {
          id
          name
        }
      }
    }
  }
`

// Typeahead for the "add company to customer" flow.
export const COMPANY_TYPEAHEAD_QUERY = gql`
  query CompanyTypeahead($query: String!) {
    searchCompanies(query: $query, per: 20) {
      id
      number
      name
      taxId
    }
  }
`

// Re-set a customer's company list. Pass the union of their existing company
// ids plus the target company to attach an existing contact without detaching
// them from any company they already belong to.
export const UPDATE_CONTACT_COMPANIES_MUTATION = gql`
  mutation UpdateContactCompanies($customerNo: String!, $customerParams: AdminCustomerInput!) {
    updateCustomer(customerNo: $customerNo, customerParams: $customerParams) {
      customer {
        id
        customerNo
        fullName
        companies {
          id
          name
        }
      }
      errors
    }
  }
`
